/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unnamed-components */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";

var _class, _temp;

import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import text from 'I18n/utils/unescapedText';
import { searchAssets } from 'DesignData/actions/finder/Assets';
import * as finderSelectors from 'DesignData/selectors/finder';
import { DEFAULT_PAGINATION_LIMIT } from 'DesignData/settings/api';
import FileModel from 'DesignData/models/finder/File';
import FolderModel from 'DesignData/models/finder/Folder';
import FolderResultItem from 'DesignFinderUI/components/results/FolderResultItem';
import FileResultItem from 'DesignFinderUI/components/results/FileResultItem';
import FileResults from 'DesignFinderUI/components/results/FileResults';
import UIPaginator from 'UIComponents/paginator/UIPaginator';

const i18nKey = key => `DesignFinderUI.results.SearchResults.${key}`;

function mapStateToProps(state) {
  return {
    results: finderSelectors.getSearchResultsAssets(state),
    activeId: finderSelectors.getCurrentlyActiveSearchAssetId(state),
    fetchError: finderSelectors.getSearchAssetsError(state),
    offset: finderSelectors.getSearchAssetsOffset(state),
    total: finderSelectors.getSearchAssetsTotal(state),
    isFetching: finderSelectors.getIsSearchingAssets(state)
  };
}

const mapDispatchToProps = {
  searchFiles: searchAssets
};
export default connect(mapStateToProps, mapDispatchToProps)((_temp = _class = class extends Component {
  constructor(props) {
    super(props);

    this.handlePageChange = event => {
      const {
        searchTerm,
        searchFiles,
        offset
      } = this.props;
      const pageNumber = event.target.value;
      const newOffset = (pageNumber - 1) * DEFAULT_PAGINATION_LIMIT;

      if (newOffset !== offset) {
        searchFiles(searchTerm, newOffset);
      }
    };

    this.resultsRenderer = ({
      asLinks,
      children,
      itemProps,
      results,
      activeId
    }) => {
      if (children) {
        return children;
      }

      return results.map(__asset => {
        let assetProps = Object.assign({}, __asset);

        if (__asset instanceof FileModel) {
          assetProps = Object.assign({}, assetProps, {
            fileType: __asset.type,
            folderPath: __asset.folderPath
          });
          return /*#__PURE__*/_createElement(FileResultItem, Object.assign({}, itemProps, {}, assetProps, {
            asLink: asLinks,
            key: __asset.id,
            fileId: __asset.id,
            onClose: this.props.onClose,
            active: activeId === __asset.id
          }));
        } else if (__asset instanceof FolderModel) {
          assetProps = Object.assign({}, assetProps, {
            folderPath: __asset.__folderPath
          });
          return /*#__PURE__*/_createElement(FolderResultItem, Object.assign({}, itemProps, {}, assetProps, {
            key: __asset.id,
            onClose: this.props.onClose,
            active: activeId === __asset.id
          }));
        }

        return null;
      });
    };

    const {
      searchFiles: _searchFiles,
      searchTerm: _searchTerm
    } = props;

    _searchFiles(_searchTerm);
  }

  renderPaginator() {
    const {
      offset,
      total,
      isFetching
    } = this.props;
    if (!total && !isFetching) return null;
    const resultsPageCount = Math.ceil(total / DEFAULT_PAGINATION_LIMIT);
    const currentPage = offset ? Math.ceil(offset / DEFAULT_PAGINATION_LIMIT + 1) : 1;
    const maxVisibleButtons = Math.min(resultsPageCount, 4);
    return /*#__PURE__*/_jsx(UIPaginator, {
      className: "p-y-5",
      page: currentPage,
      pageCount: resultsPageCount,
      maxVisiblePageButtons: maxVisibleButtons,
      onPageChange: this.handlePageChange
    });
  }

  render() {
    const {
      isFetching,
      total,
      searchTerm
    } = this.props;
    let headerTextKey = 'header';

    if (isFetching) {
      headerTextKey = 'header.fetching';
    } else if (!total) {
      headerTextKey = 'header.noResults';
    }

    const headerText = text(i18nKey(headerTextKey), {
      count: total || 0,
      searchTerm: I18n.SafeString(searchTerm)
    });
    return /*#__PURE__*/_jsx(FileResults, Object.assign({}, this.props, {
      headerText: headerText,
      resultsRenderer: this.resultsRenderer,
      footer: this.renderPaginator()
    }));
  }

}, _class.propTypes = Object.assign({}, FileResults.propTypes, {
  offset: PropTypes.number,
  total: PropTypes.number,
  searchFiles: PropTypes.func.isRequired,
  searchTerm: PropTypes.string.isRequired
}), _class.defaultProps = Object.assign({}, FileResults.defaultProps), _temp));